module.exports = __webpack_public_path__ + "img/crown.3903c2b0.svg";